import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-table-default',
  templateUrl: './table-default.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*', overflow: 'hidden' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ),
    ]),
  ],
  styleUrls: ['./table-default.component.scss'],
})
export class TableDefaultComponent implements OnChanges, OnInit {
  @Input() dataSource!: MatTableDataSource<any> | any[];
  @Input() displayedColumns: string[] = [];
  @Input() arrayStatus!: [{ label: string; property: string }];
  @Input() sortState: any;
  @Input() screenWidth: number = 1025;
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() customClassFilters: boolean = false;
  @Input() pageIndex: number = 0;
  @Input() totalPages: number = 1;
  @Input() criterios: any = [];
  @Input() expansivel: boolean = false;
  @Input() columnConfig: {
    columnDef: string;
    header: string;
    nativePipe: '';
    pipeArgs: '';
    property?: string;
    pipe?: 'date' | 'uppercase' | 'lowercase';
    custom?: boolean;
    customTd?: boolean;
  }[] = [];
  @Input() totalElements: number = 0;
  @Input() pageSize: number = 10;
  @Input() from: string = '';
  @Input() status: boolean = false;
  @Input() alterarStatus: boolean = false;
  @Input() filterStatus: boolean = false;
  @Input() visualizar: boolean = false;
  @Input() criar: boolean = false;
  @Input() editar: boolean = false;
  @Input() excluir: boolean = false;
  @Input() assinar: boolean = false;
  @Input() acoes: boolean = false;
  @Input() ordenacao: boolean = true;
  @Input() filtros: boolean = false;
  @Input() filtro: boolean = true;

  @Input() textButtonCreate: string = 'Adicionar';
  @Input() criteriosLabels: { [key: string]: string } = {};
  @Input() ariaLabel: string = 'Campo para busca';
  @Input() placeholder: string = 'Buscar';
  @Output() sortChange = new EventEmitter<string>();
  @Output() create = new EventEmitter<number>();
  @Output() edit = new EventEmitter<number>();
  @Output() delete = new EventEmitter<number>();
  @Output() view = new EventEmitter<number>();
  @Output() viewAnalise = new EventEmitter<{}>();
  @Output() sign = new EventEmitter<{}>();
  @Output() activate = new EventEmitter<number>();
  @Output() inactivate = new EventEmitter<number>();
  @Output() openHistory = new EventEmitter<number>();
  @Output() openFilter = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() filterText = new EventEmitter<string>();
  @Output() criterioRemoved = new EventEmitter<{}>();
  @Output() filterStatusChanged = new EventEmitter<string>();
  @Output() transitionStatusChanged = new EventEmitter<{}>();
  @Output() rowExpanded = new EventEmitter<{}>();
  expandedElement: any | null = null;

  constructor() {}
  ngOnInit(): void {
    if (
      Array.isArray(this.dataSource) &&
      this.dataSource.every((item) => item.hasOwnProperty('dados'))
    ) {
      let registrosValidos = this.dataSource as any[];

      this.dataSource = new MatTableDataSource(
        registrosValidos.map((registro: any) => ({
          numLinha: registro.numLinha,
          ordem: registro.ordem,
          ...registro.dados,
        })),
      );
    }
  }
  ngOnChanges(changes: SimpleChanges): void {}
  onSortChange(field: string) {
    this.sortChange.emit(field);
  }

  emitEvent(event: EventEmitter<number>, id: number) {
    event.emit(id);
  }
  emitSignEvent(id: string, userId: string) {
    const data = {
      id: id,
      userId: userId,
    };
    this.sign.emit(data);
  }
  filterStatusChange(status: string) {
    this.filterStatusChanged.emit(status);
  }
  transitionStatusChange(id: string, status: string, data: any) {
    const values = {
      data: data,
      transicaoId: id,
      transicaoNome: status,
    };
    this.transitionStatusChanged.emit(values);
  }
  getValue(row: any, path?: string, pipe?: string): any {
    if (!path) return '';

    const value = path.split('.').reduce((acc, part) => acc?.[part], row);

    if (pipe === 'date') {
      return value ? new Date(value).toLocaleDateString('pt-BR') : '';
    }

    if (pipe === 'uppercase') return value?.toString().toUpperCase();
    if (pipe === 'lowercase') return value?.toString().toLowerCase();
    return value;
  }
  pageChangeEvent(event: PageEvent) {
    this.pageChange.emit(event);
  }

  getSingularOrPlural(medida: any, valor: any) {
    let result;

    return result;
  }

  getMedidaFormatada(valor: any, medida: any): string {
    if (!medida || valor == null) return '';
    const defaultMedida = medida;
    const medidaLower = medida.toLowerCase();

    const singularMap: any = {
      dias: 'Dia',
      meses: 'Mês',
      anos: 'Ano',
      horas: 'Hora',
    };

    if (valor === 1 || valor < 1) {
      return singularMap[medidaLower] || medidaLower;
    }

    return defaultMedida;
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length >= 3 || filterValue.length === 0) {
      this.filterText.emit(filterValue);
    }
  }

  openModalFilters(popoverRef?: any) {
    this.openFilter.emit(popoverRef);
  }
  openViewAnalise(row: any, idAnalise: any) {
    const data = {
      data: row,
      idAnalise: idAnalise,
    };
    this.viewAnalise.emit(data);
  }
  removerCriterio(criterio: string, popoverRef: any) {
    const data = {
      criterio: criterio,
      popoverRef: popoverRef,
    };
    this.criterios = this.criterios.filter((c: any) => c !== criterio);
    this.criterioRemoved.emit(data);
    if (this.criterios.length == 0) {
      if (popoverRef) {
        popoverRef.dismiss();
      }
    }
  }
  getLabelCriterio(criterio: string): string {
    return this.criteriosLabels[criterio] || 'Critério Desconhecido';
  }

  toggleRow(row: any) {
    this.expandedElement = this.expandedElement === row ? null : row;
    if (this.expandedElement === row) {
      this.rowExpanded.emit(this.expandedElement);
    }
  }
  isExpansionDetailRow = (index: number, row: any) =>
    row.hasOwnProperty('detailRow');
  isNormalRow = (index: number, row: any): boolean => !row.detailRow;
  isDetailRow = (index: number, row: any): boolean => {
    return row.detailRow === true;
  };
}
